import { useEffect, useState } from "react";
import { GetContaChatHistoricoService } from "../../../../Services/HelpDesk/ContaChat/ContaChatService";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import Mensagens from "../../../../Components/CardsPages/Mensagens";
import { IMensagem } from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";

export default function ModalContaChatHistorico(ID_CONTA_CHAT: number) {
    const [lstChatHistorico, setChatHistorico] = useState<Array<IMensagem>>([]);

    useEffect(() => {
        GetContaChatHistoricoService(ID_CONTA_CHAT).then((res) =>
            setChatHistorico(
                res.data.map((mensagem_historico) => ({
                    Body: mensagem_historico.DS_HISTORICO,
                    IdContaChat: mensagem_historico.ID_CONTA_CHAT,
                    IdUsuario: mensagem_historico.ID_USUARIO,
                    MediaContentType0: mensagem_historico.DS_CONTENT_TYPE,
                    MediaUrl0: mensagem_historico.DS_URL,
                    MensagemCliente: !mensagem_historico.FL_USUARIO,
                    TimeStamp: new Date(
                        mensagem_historico.DT_HISTORICO
                    ).getTime(),
                    TimeStampSync: true,
                }))
            )
        );
    }, [ID_CONTA_CHAT]);

    return lstChatHistorico.length ? (
        <Mensagens mensagens={lstChatHistorico} />
    ) : (
        <SpinnerComponent />
    );
}
